import React, { FC } from "react"
import { LinkProps, Link, InternalIcon, SurfaceColor, Card } from "@carrotfertility/carotene-core"
import { FormattedMessage, useIntl } from "react-intl"
import { getHelpCenterLink, goToHelpCenter } from "#/lib/carrot-api/HelpCenterClient"

type ZendeskArrowLinkProps = {
  supportCenterLink?: string
} & LinkProps

const ZendeskArrowLink: FC<ZendeskArrowLinkProps> = ({ supportCenterLink, ...props }: ZendeskArrowLinkProps) => {
  let zdLinkFragment = supportCenterLink
  // Contentful zendesk links will be provided via the "to" and they will be full URLs to zendesk, so parse out the fragment
  // e.g. https://get-carrot.zendesk.com/hc/sections/4410088379931-Carrot-Plans
  if (props.href) {
    const path = props.href?.split("/")
    zdLinkFragment = path[path.length - 2] + "/" + path[path.length - 1]
  }

  return (
    <Link
      href={getHelpCenterLink(zdLinkFragment)}
      onClick={(event) => goToHelpCenter(event, zdLinkFragment)}
      target={"_blank"}
      endIcon={<InternalIcon fontSize="small" color="primary" />}
    >
      {props.children}
    </Link>
  )
}

export function HelpCenterModule({ color = "primary" }: { color?: SurfaceColor }): JSX.Element {
  const intl = useIntl()
  return (
    <Card
      variant="secondary"
      color={color}
      id="home-sidebar-help-center-module"
      title={intl.formatMessage({ defaultMessage: "Get answers to frequently asked questions" })}
      primaryAction={
        <ZendeskArrowLink>
          <FormattedMessage defaultMessage="Visit Help Center" />
        </ZendeskArrowLink>
      }
    />
  )
}
